import { render, staticRenderFns } from "./NovelTemplate.vue?vue&type=template&id=5571d716&scoped=true"
var script = {}
import style0 from "./NovelTemplate.vue?vue&type=style&index=0&id=5571d716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571d716",
  null
  
)

export default component.exports